<app-iframe
  class="iframe"
  *ngIf="webviewUrl$ | async as url; else loader"
  [url]="url"
></app-iframe>

<ng-template #loader>
  <i2g-loader></i2g-loader>
</ng-template>
